<template>
  <div class="content background2">
    <div class="tab">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="人员管理" name="/static/system/manage" v-if="this.menuList.indexOf('CD_610') != -1"></el-tab-pane>
        <el-tab-pane label="角色管理" name="/static/system/role" v-if="this.menuList.indexOf('CD_620') != -1"></el-tab-pane>
        <el-tab-pane label="区域管理" name="/static/system/area" v-if="this.menuList.indexOf('CD_630') != -1"></el-tab-pane>
        <el-tab-pane label="时间管理" name="/static/system/time" v-if="this.menuList.indexOf('CD_640') != -1"></el-tab-pane>
        <el-tab-pane label="客户管理" name="/static/system/customer" v-if="this.menuList.indexOf('CD_650') != -1"></el-tab-pane>
        <el-tab-pane label="设备管理" name="/static/system/equipment" v-if="this.menuList.indexOf('CD_660') != -1"></el-tab-pane>
        <el-tab-pane label="字典管理" name="/static/system/dictionary" v-if="this.menuList.indexOf('CD_670') != -1"></el-tab-pane>
      </el-tabs>
    </div>
    <div style="width: 100%;height:100%;position: absolute;top:0;left:0;padding:70px 0 10px;">
      <div style="width: 100%;height:100%;position: relative;">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
  import "@/assets/css/alarm/list.css"
  import Page from "@/components/common/page";

  export default {
    name: 'alarm',
    components: {
      Page
    },
    data() {
      return {
        value1: '',
        activeName: 'manage',
        options: [],
        checkList2: ['选中且禁用', '复选框 A'],
        checkList: [],
        menuList: [],
        multipleSelection: [],
        pageCount: 20,
        pageSize: 1,
        pageNo: 10,
      }
    },
    methods: {
      queryArea(){},
      handler() {

      },
      clickHandler(e) {
        this.show = true;
        this.marker = {
          lng: e.lng,
          lat: e.lat
        };
      },
      handleClick(tab, event) {
        this.$router.push({
          path: tab.name
        });
      },
      search(param) {

      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      }
    },
    created() {
      this.activeName = this.$route.path;
      /* if (sessionStorage.getItem('store')) {
        this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
      } */
      this.menuList = this.$store.getters.getMenuPermission;
    }
  }
</script>

<style>
  .tab .el-tabs__content {
    width: 100%;
    height: 100%;
  }
  .tab .el-tabs__header {
    background: #fff;
    margin: 0 0 10px;
    border-left: 5px solid #2CBA85;
  }

  .tab .el-tabs__nav-wrap::after {
    background: none;
  }

  .tab .el-tabs__item {
    padding: 10px 25px;
    height: 60px;
    text-align: center;
    font-weight: bold;
    letter-spacing: 1px;
    font-size: 16px;
  }
  .tab .el-tabs--top .el-tabs__item.is-top:nth-child(2){
    padding-left: 25px;
  }
  .tab .el-tabs__item.is-active ,.tab .el-tabs__item:hover{
    color: #2CBA85;
  }
  .tab .el-tabs__active-bar{
    background: #2CBA85;
  }
  .tab .navTable{
    background: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/system/list.vue